const roles = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
};

export default {
  roles: roles,
  authenSuccesUrlRedirect: function (hasAuthor) {
    // if (hasAuthor(roles.CREATE)) {
    //   return '/user-management/managed-users';
    // } else if (hasAuthor(roles.CREATE)) {
    //   return '/user-management/managed-users';
    // } else {
    //   return '/user-management/managed-users';
    // }
    return '/dashboard.html'
  },

  authorizationMapper: [
    {
      regex: /^\/dashboard.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/devices-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/files-screen-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/schedule-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/history-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/administrator\/user-activity-log.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.USER);
      }
    },
    {
      regex: /^\/user-management\/managed-users.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/pi-action-config.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/managed-org.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/thread.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    }
    ,
    {
      regex: /^\/administrator\/managed-license.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    }
    ,
    {
      regex: /^\/administrator\/managed-widget.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    }
  ]
}
